/**
 * File defining appropriate types to store a SIRE number into a SQL database
 */

import { StringMarshaller } from "@cervval.js/common-sql-core/src/marshallers/string.marshaller";
import { FieldMarshaller } from "@cervval.js/common-sql-core/src/sql.common";
import { SIRET } from "../tools/siret.tools";

export type SIRETFieldTypes = {
    "SIRET": SIRET
}

export type SIRETFieldTypeName = keyof SIRETFieldTypes;

/**
 * Build a record with a ```SIRETFieldTypeName``` as key and an appropriate marshaller for database storage as value
 */
export function getMarshallerRecordForSIRETFieldTypes():
    { [Type in SIRETFieldTypeName]?: FieldMarshaller<SIRETFieldTypes[Type]> } {
    return {
        SIRET: new StringMarshaller({ sanitizeHtml: true, replaceEmptyStringWithNull: true, maxLength: 16 })
    };
}